import { useMemo, useCallback } from 'external/react';
import CourseList from './CourseList';
import PlanInfo from 'components/PlanInfo';
import SelectStudent from 'components/SelectStudent';
import SelectTutor from 'components/SelectTutor';
import useAdmin from 'context/admin-context/hook';

interface PurchaseDetailProps {
  index: number;
}

const PurchaseDetail = ({ index }: PurchaseDetailProps) => {
  const { state, updateChangeCourseModal } = useAdmin();
  const purchase = state.client.purchases.items[index];
  if (!purchase) return null;

  const extra = useMemo(() =>
    state.courseMap !== false && purchase.courses.extra.length > 0
    ? purchase.courses.extra.map(c => state.courseMap[c])
    : [], [purchase.courses.extra, state.courseMap])

  const handleCourseClick = useCallback(({id, source}) => {
    updateChangeCourseModal(
      true,
      index,
      id,
      { course: id, subject: '', grade: '', source},
      null
    );
  }, [index, updateChangeCourseModal]);

  return (
    <div>
      <PlanInfo packageItem={purchase} />
      <div className='d-flex mt-3 gap-3'>
        <SelectStudent packageItem={purchase} />
        <SelectTutor packageItem={purchase} />
      </div>
      <CourseList courses={purchase.courses.basic || []} source='basic' onCourseClick={handleCourseClick} />
      <CourseList courses={purchase.courses.elective || []} source='elective' onCourseClick={handleCourseClick} />
      <CourseList courses={extra} source='extra' onCourseClick={handleCourseClick} />
    </div>
  );
};

export default PurchaseDetail;